import { STARTERS, COMPOSER_TOOLS } from './prompts';

/** Build home lede + starters from Get Started / bootstrap care_profile. */
export function careHeadline(care) {
  if (!care) return null;
  const type = String(care.cancer_type || '').trim();
  const stage = String(care.cancer_stage || '').trim();
  if (type && stage) return `Continue with your ${stage} ${type} plan`;
  if (type) return `Continue with your ${type} plan`;
  if (stage) return `Continue with your stage ${stage} plan`;
  if (care.onboarding_completed) return 'Your care profile is ready. Pick up where you left off.';
  return null;
}

export function careSearchSeed(care) {
  if (!care) return '';
  const cities = Array.isArray(care.preferred_cities) ? care.preferred_cities.filter(Boolean) : [];
  if (cities.length) return String(cities[0]);
  if (care.city) return String(care.city);
  if (care.cancer_type) return String(care.cancer_type);
  return '';
}

export function personalizedStarters(care) {
  if (!care?.cancer_type && !care?.cancer_stage) return STARTERS;
  const type = String(care.cancer_type || '').trim();
  const stage = String(care.cancer_stage || '').trim();
  const label = [stage, type].filter(Boolean).join(' ');
  const cities = Array.isArray(care.preferred_cities)
    ? care.preferred_cities.filter(Boolean).slice(0, 3).join(', ')
    : '';
  const place = cities || care.city || '';

  return STARTERS.map((item) => {
    if (item.id === 'treatment' && label) {
      return {
        ...item,
        title: `Walk me through ${label}`,
        label: 'From your care profile',
        text:
          `I already shared that I have ${label}. Walk me through treatment the way an oncology clinic would explain it: what visits look like, common side effects, and the questions that get a clearer plan sooner. Do not invent a protocol or change doses.`,
      };
    }
    if (item.id === 'appointment' && label) {
      return {
        ...item,
        title: `Prep my ${label} visit`,
        label: 'Clinic prep',
        text:
          `Help me walk into my next oncology visit ready. My care profile says ${label}` +
          (place ? ` and I am looking at care in ${place}` : '') +
          `. Give me a short list of questions I can actually ask in the room. Do not diagnose or change treatment.`,
      };
    }
    if (item.id === 'side-effects' && label) {
      return {
        ...item,
        text:
          `I'm dealing with ${label}. Help me sort what I'm feeling into what I should mention at my next oncology visit, and what is worth calling the clinic about today. I will describe what I'm noticing. Do not change any doses.`,
      };
    }
    return item;
  });
}

export function personalizedComposerTools(care) {
  const starters = personalizedStarters(care);
  const byId = Object.fromEntries(starters.map((row) => [row.id, row]));
  return COMPOSER_TOOLS.map((section) => ({
    ...section,
    items: section.items.map((item) => {
      const match = byId[item.id];
      if (!match || item.kind !== 'prompt') return item;
      return {
        ...item,
        title: match.title || item.title,
        detail: match.label || item.detail,
        text: match.text || item.text,
      };
    }),
  }));
}
